import React, { useState, lazy, Suspense} from "react";

import Button from "../ui/Button";

import Modal from "./Modal";


const PdfViewer = lazy(() => import("../common/pdf/PdfViewer"));

export default function BrochureSection({ url, className, title }) {
  const [showPdf, setShowPdf] = useState(false);


  return (
    <div className={`brochure-section rounded-lg bg-gray-100 p-2 ${className}`}>
        <div className="d-flex justify-between align-center">
        {title && <div className="fw-semibold text-sm  brochure-title">{title}</div>}
      <Button
            variant="secondary"
            size="sm"
            onClick={() => setShowPdf(!showPdf)}
          >
            {showPdf ? "Hide" : "View"}
          </Button>
        </div>

      {showPdf && (
        <Modal isOpen={showPdf} className="brochure-viewer-modal" onClose={() => setShowPdf(false)} title="Brochure">
          <div className="">
            <Suspense fallback={<div>Loading PDF...</div>}>
              <PdfViewer fileUrl={url} height="90vh" />
            </Suspense>
          </div>
        </Modal>
      )}
    </div>
  );
}
